import React from "react";
import Card from "@material-ui/core/Card";
import { makeStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import SaveIcon from "@material-ui/icons/Save";


const videos = [
  'https://res.cloudinary.com/duc1h2b7v/video/upload/v1761296841/BWLoop3_b4nwg7.mp4',
  'https://res.cloudinary.com/duc1h2b7v/video/upload/v1761232676/basic_7-min_znedwb.mp4',
  'https://res.cloudinary.com/duc1h2b7v/video/upload/f_auto,q_auto/v1761232535/windrad_white_1_dmgvn8.mp4',
];

const randomVideo = videos[Math.floor(Math.random() * videos.length)];

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(1),
    width: "100%",
    height: 400,
    display: "flex",
    justifyContent: "flex-start",
    backgroundColor: "rgb(72, 72, 72)",
    borderRadius: "0px",
    position: "relative",
    overflow: "hidden",
  },
  video: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  header: {
    Color: "#ff69b4",
    display: "flex",
    alignItems: "center",
    padding: "0.5rem",
    backgroundColor: "#F5F5F5"
  },
  spacer: {
    Color: "#ff69b4",
    flexGrow: 1,
    backgroundColor: "#F5F5F5"
  },
  body: {
    Color: "#ff69b4",
    padding: "0.5rem",
    flexGrow: 1,
    backgroundColor: "#F5F5F5"
  }
}));

export default function TopBar({
}) {
  const classes = useStyles();
  
  return (
    <Card className={classes.root}>
      <video
        className={classes.video}
        autoPlay
        loop
        muted
        playsInline
      >
        <source src={randomVideo} type="video/mp4" />
      </video>
    </Card>
  );
}